import VueRouter from 'vue-router';

// Vue Templates
import Home from '@/views/Home.vue';
import FB from '@/views/FB.vue';

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
    },
    {
        path: '/fb',
        name: 'FB',
        component: FB,
    },
];

const router = new VueRouter({
    base: '/',
    mode: 'history',
    routes,
});

export default router;
